<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-inputnumber [(ngModel)]="value" [useGrouping]="true" [groupSeparator]="'.'" size="small" mode="decimal"
      inputId="withoutgrouping" class="w-full decimal-input" appendTo="body" [ngClass]="recovery ? 'recover-data' : ''"
      [disabled]="disabled" [decimalSeparator]="','" [minFractionDigits]="2" [maxFractionDigits]="maxFractionDigits"
      autocomplete="off" (onBlur)="changeNumber()" (onFocus)="selectAllText($event)" />
  </div>
</ng-container>